module.exports = __webpack_public_path__ + "static/media/speedometer.fbac60df.svg";